// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9640) return "static/chunks/9640-61eba4ff4b4f975b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"337":"79990bdefb27167d","2875":"6d95cda3df23bcd0","4486":"e8610923315c76da"}[chunkId] + ".js";
};